(function ($) {
  $(function () {
    // Set the --viewport-height CSS variable to 1% of the viewport height
    document.documentElement.style.setProperty(
      '--viewport-height',
      window.innerHeight * 0.01 + 'px'
    );

    // Function to scroll smoothly to the element
    function smoothScrollToHash(hash) {
      var target = $(hash);
      if (target.length) {
        $('html, body').animate(
          { scrollTop: target.offset().top - 100 },
          800 // Duration in milliseconds
        );
      }
    }

    // Scroll on page load if there's a hash in the URL
    if (window.location.hash) {
      smoothScrollToHash(window.location.hash);
    }

    // Smooth scrolling when clicking anchor links
    $('a[href^="#"]').on('click', function (e) {
      e.preventDefault();
      var hash = this.hash;
      if (hash) {
        smoothScrollToHash(hash);
        history.pushState(null, null, hash); // Update URL without reloading
      }
    });
  });
})(jQuery);
